import { render } from "./VvBottomNavigation.vue?vue&type=template&id=ef3ad7a2&scoped=true"
import script from "./VvBottomNavigation.vue?vue&type=script&lang=js"
export * from "./VvBottomNavigation.vue?vue&type=script&lang=js"

import "./VvBottomNavigation.vue?vue&type=style&index=0&id=ef3ad7a2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef3ad7a2"]])

export default __exports__